<template>
<MapContainer>

</MapContainer>
</template>

<style lang="scss" scoped>

</style>

<script>
import MapContainer from '@/components/MapContainer.vue'

// Mixin
import {restVisor} from '@/components/mixin/restVisor.js'
import {restLayerActivity} from '@/components/mixin/restLayerActivity.js'
import {mapService} from '@/services/map/mapService'
import {restSymbology} from '@/components/mixin/restSymbology.js'
import {vuex} from '@/components/mixin/vuex.js'

export default{
  name: 'home',
  mixins: [restVisor, restSymbology, restLayerActivity, vuex],
  data(){
    return{

      }
  },
  components:{
      MapContainer
  },
  computed: {
  },
  props: [],
  methods:{
    // Carga masiva de filtros guardados de todas las capas del catálogo del
    // mapa (junto a loadSymbologiesForLayers) — evita una petición por fila
    // en ListPlegable.vue. A diferencia de esa, no se filtra por proveedor:
    // los filtros guardados aplican a cualquier capa. Las capas importadas
    // no forman parte de este catálogo (store/modules/savedFilters.js las
    // cubre con una carga perezosa al abrir su modal).
    loadSavedFiltersForLayers() {
      const ids = (this.$store.getters.getLayers || [])
        .reduce((acc, category) => acc.concat(category.layers || []), [])
        .map(layer => layer.id)
      this.$store.dispatch('savedFilters/loadForLayers', ids)
    },
    // Las capas WMS/WFS de sesión las agrega el usuario por URL y no pertenecen
    // al catálogo de ningún mapa: si no se descartan acá siguen dibujadas y
    // listadas en Lista de Capas del mapa siguiente.
    clearWmsSessionLayers() {
      const layers = this.$store.getters.getWmsSessionLayers || []
      layers.slice().forEach(layer => {
        mapService.removeLayer(layer.id)
        this.endLayerSession(layer)
        this.$store.dispatch('removeWmsSessionLayer', layer)
      })
    },
    reloadSymbologiesOnVisible() {
      if (document.visibilityState === 'visible') this.loadSymbologiesForLayers()
    },
    // Carga el estado del mapa (herramientas, capas, geoprocesos). Se usa tanto
    // al entrar por primera vez (mounted) como al cambiar de mapa navegando
    // entre dos rutas /visor/:idMap, caso en que Vue Router reutiliza la
    // instancia del componente y mounted() no vuelve a ejecutarse.
    loadMapData(idMap, terrainCampaignId) {
      // Reset all tool state on every map entry (prevents stale state across navigation)
      this.$store.commit('resetMapToolsSelection')
      this.$store.dispatch('attributeTable/closeTable')
      this.clearWmsSessionLayers()
      // QA-11: limpiar la configuración del mapa anterior ANTES de pedir la nueva,
      // para que no se filtre entre mapas mientras llega la respuesta.
      this.$store.dispatch('setEnabledMapTools', null)
      this.getToolsAssigned(idMap)
      // "Ver en el mapa" (TerrainCampaigns.vue::goToMap) navega con
      // ?terrainCampaignId=X esperando que la capa de esa campaña se active y
      // su tabla de atributos se abra sola (TerrainSection.vue::
      // activateFromCampaignQuery). Pero TerrainSection.vue solo se monta
      // cuando la herramienta "layers" está activa (ver v-if en
      // ToolContainer.vue), así que sin este dispatch su watcher `immediate`
      // nunca llega a correr y la capa no se activaba hasta que el usuario
      // abría el panel de Capas a mano. Va DESPUÉS del reset de arriba para
      // que no quede pisado por él.
      if (terrainCampaignId) {
        this.$store.dispatch('setMapToolSelection', { tool: 'layers', active: true })
      }
      this.getLayersAssigned(idMap).then(() => {
        this.loadSymbologiesForLayers()
        this.loadSavedFiltersForLayers()
      })
      this.getGeoprocessingsAssigned(idMap)
    },
  },
  updated () {

  },
  created () {
    //Verificar permisos
    this.$store.getters.getPermissions? true:this.$router.push('/inicio')
    this.$store.getters.getPermissions.visor? true:this.$router.push('/pagina-no-encontrada')
  },
  mounted () {
    this.loadMapData(this.$route.params.idMap, this.$route.query.terrainCampaignId)
    document.addEventListener('visibilitychange', this.reloadSymbologiesOnVisible)
  },

  beforeRouteUpdate (to, from, next) {
    this.loadMapData(to.params.idMap, to.query.terrainCampaignId)
    next()
  },

  beforeDestroy () {
    document.removeEventListener('visibilitychange', this.reloadSymbologiesOnVisible)
  },

}
</script>
